var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFiltersReset = function SvgFiltersReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.803 4a6 6 0 1 1-.72 4H.071A7.002 7.002 0 0 0 14 7 7 7 0 0 0 1 3.392V0H0v5h5V4H1.803z",
    fillRule: "evenodd"
  })));
};
export default SvgFiltersReset;